module.exports = __webpack_public_path__ + "img/5.a5ab048a.png";